'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';

interface HeaderProps {
  onInquire: () => void;
}

export default function Header({ onInquire }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'About', href: '#about' },
    { label: 'Instagram', href: 'https://instagram.com/tony.taylxr', external: true },
    { label: 'Studio', href: 'https://heaviside.club', external: true },
  ];

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled ? 'rgba(245,242,237,0.92)' : 'transparent',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(26,26,26,0.06)' : '1px solid transparent',
      }}
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        {/* Logo — links back to landing */}
        <a href="#landing" className="cursor-pointer flex items-center">
          <Image
            src="/assets/images/HEAVISIDE-1773124406829.png"
            alt="Heaviside logo"
            width={140}
            height={40}
            style={{
              filter: scrolled ? 'none' : 'none',
            }}
            className="object-contain"
            priority
          />
        </a>

        {/* Nav links */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(({ label, href, external }) => (
            <a
              key={label}
              href={href}
              {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              className="text-xs font-semibold uppercase tracking-[0.18em] transition-colors duration-200"
              style={{
                color: 'var(--burnished-pewter)',
                fontFamily: 'Manrope, sans-serif',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.color = 'var(--brayer-red)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.color = 'var(--burnished-pewter)';
              }}
            >
              {label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <button
          onClick={onInquire}
          className="text-xs font-bold uppercase tracking-[0.18em] px-5 py-2.5 transition-colors duration-300"
          style={{
            background: 'transparent',
            color: 'var(--burnished-pewter)',
            border: '1px solid var(--plate-gray)',
            fontFamily: 'Manrope, sans-serif',
          }}
          onMouseEnter={(e) => {
            const el = e.currentTarget as HTMLButtonElement;
            el.style.background = 'var(--brayer-red)';
            el.style.borderColor = 'var(--brayer-red)';
            el.style.color = 'var(--cotton-rag)';
          }}
          onMouseLeave={(e) => {
            const el = e.currentTarget as HTMLButtonElement;
            el.style.background = 'transparent';
            el.style.borderColor = 'var(--plate-gray)';
            el.style.color = 'var(--burnished-pewter)';
          }}
        >
          Enquire
        </button>
      </div>
    </header>
  );
}